
<template>
  <div id="dashboard-analytics">
    <div class="vx-row">

      <!-- CARD 1: SUBSCRIBERS GAINED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line class='font-20' icon="UsersIcon" statistic="Active Partners" :statisticTitle="totalActivePartnerCount" :statisticSubTitle="`in ${totalPartnerCount}`" :chartData="subscribersGained.series" type="area"></statistics-card-line>
      </div>

      <!-- CARD 2: ORDER RECIEVED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line class='font-20' icon="ShoppingBagIcon" statistic="Active Clients" :statisticTitle="totalActiveClientCount" :statisticSubTitle="`in ${totalClientCount}`" :chartData="subscribersGained.series" color="warning" type="area"></statistics-card-line>
      </div>
   
      <!-- CARD 3: SUBSCRIBERS GAINED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line class='font-20' icon="UsersIcon" statistic="Active Codes" :statisticTitle="totalActiveCodeCount" :statisticSubTitle="`in ${totalCodeCount}`" :chartData="subscribersGained.series" type="area"></statistics-card-line>
      </div>

      <!-- CARD 4: ORDER RECIEVED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line class='font-20 height-2' icon="ShoppingBagIcon" statistic="Payments" :statisticTitle="totalAmount" statisticSubTitle="" :chartData="subscribersGained.series" color="warning" type="area"></statistics-card-line>
      </div>
    </div>

    <div class="vx-row">
      <!-- CARD 5: SUPPORT TRACKER -->
      <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">

           <div class="vx-col w-full">
             <vx-card title="Partners" code-toggler>
                <vue-apex-charts type="bar" height="350" :options="partnerOptions" :series="partnerSeries"></vue-apex-charts>
              </vx-card>
                <!-- <echarts-bar-chart-partners></echarts-bar-chart-partners> -->
            </div>
      </div>
      <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
          <div class="vx-col w-full">
            <vx-card title="Clients" code-toggler>
              <vue-apex-charts type="bar" height="350" :options="clientOptions" :series="clientSeries"></vue-apex-charts>
            </vx-card>
          </div>
      </div>
    </div>
       <div class="vx-row">
    <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
       <vx-card title="Payments">  
          <vue-apex-charts type="line" height="350" :options="chartOptions" :series="series"></vue-apex-charts>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <vx-card title="Client Types">     
          <vue-apex-charts type="donut" height="350" :options="optionsClientType" :series="seriesClientType"></vue-apex-charts>
        </vx-card>
      </div>
    </div>
       <div class="vx-row">
      <!-- CARD 5: SUPPORT TRACKER -->
      <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <partners-table></partners-table>
      </div>
      <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <clients-table></clients-table>
      </div>
    </div>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'
import VxTimeline from '@/components/timeline/VxTimeline'
import EchartsBarChartPartners from './charts/barchartPartners.vue'
import EchartsBarChartClients from './charts/barchartClients.vue'
import apexChatData from './apexChartData.js'
import PartnersTable from './table/partnersTable.vue'
import ClientsTable from './table/clientsTable.vue'
import PartnerService from "@/services/PartnerService";
import PaymentService from "@/services/PaymentService";
import PartnerCodesService from "@/services/PartnerCodesService";
import ClientService from "@/services/ClientService";
import EarningService from '@/services/EarningService';
import UtilService from "@/services/UtilService";
import analyticsData from "../ui-elements/card/analyticsData.js";
import UserService from "@/services/UserService";


export default {
  data () {
    return {
      subscribersGained: {},
      partners: [],
      sessionsData: {},
      totalClientCount: 0,
      totalPartnerCount: 0,
      totalCodeCount: 0,
      totalAmount: 0,
      totalActivePartnerCount: 0,
      totalActiveClientCount: 0,
      totalActiveCodeCount: 0,
      totalActiveClientCountByMonth:[],
      totalClientCountByMonth:[],
      totalPartnerCountByMonthList:[],
      totalActivePartnerCountByMonthList:[],
      apexChatData,
      analyticsData,
      dispatchedOrders: [],
      amount: [0,0,0,0,0,0,0,0,0,0,0,0],
      paymentAmount: [0,0,0,0,0,0,0,0,0,0,0,0],
        series: [{
            name: 'Payments',
            type: 'line',
            data: []
          }, {
            name: 'Earnings',
            type: 'line',
            data: []
          }],
          chartOptions: {
            chart: {
              height: 350,
              type: 'line',
              stacked: false,
              toolbar: {
                show: true,
                tools: {
                  download: true,
                  selection: false,
                  zoom: false,
                  zoomin: false,
                  zoomout: false,
                  pan: false,
                  reset: false ,
                }
              },
            },
            stroke: {
              curve: 'smooth',
            },
            fill: {
              type:'solid',
              opacity: [0.35, 1],
            },
            labels: ['Jan', 'Feb','Mar','Apr','May','June','July','Aug','Sep','Oct','Nov','Dec'],
            markers: {
              size: 0
            },
            yaxis: [
              {
                title: {
                  text: 'Payments',
                },
              },
              {
                opposite: true,
                title: {
                  text: 'Earnings',
                },
              },
            ],
            tooltip: {
              shared: true,
              intersect: false,
              y: {
                formatter: function (y) {
                  if(typeof y !== "undefined") {
                    return  y.toFixed(0) + "";
                  }
                  return y;
                }
              }
            }
          },
          seriesClientType: [],
          optionsClientType: {
            chart: {
              type: 'donut',
              toolbar: {
                show: true
              },
            },
            labels: ['Per Minute', 'One Time', 'Percentage','Pre Paid'],
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }]
          },
          clientSeries: [{
            name: 'Active',
            data: []
          }, {
            name: 'Total',
            data: []
          }],
        clientOptions: {
          plotOptions: {
            bar: {
              horizontal: false,
              endingShape: 'rounded',
              columnWidth: '55%',
            },
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },

          xaxis: {
            categories: ['Jan','Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct','Nov','Dec'],
          },
          yaxis: {

          },
          fill: {
            opacity: 1

          },
          tooltip: {
          }
        },
        partnerSeries: [{
            name: 'Active',
            data: []
          }, {
            name: 'Total',
            data: []
          }],
        partnerOptions: {
          plotOptions: {
            bar: {
              horizontal: false,
              endingShape: 'rounded',
              columnWidth: '55%',
            },
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
           xaxis: {
            categories: ['Jan','Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct','Nov','Dec'],
          },
          yaxis: {

          },
          fill: {
            opacity: 1

          },
          tooltip: {
          }
        },
    }
  },
  components: {
    EchartsBarChartPartners,
    EchartsBarChartClients,
    VueApexCharts,
    StatisticsCardLine,
    ChangeTimeDurationDropdown,
    VxTimeline,
    PartnersTable,
    ClientsTable
  },
  computed:{
    partnersData () {
      return this.partners
    },
  },
  methods: {
    getPartners() {
      if(this.userInfo){
        PartnerService.getAll(this.userInfo).on("value", (items) => {
          this.totalPartnerCount = 0
          this.totalActivePartnerCount = 0
          this.totalPartnerCountByMonthList = [0,0,0,0,0,0,0,0,0,0,0,0]
          this.totalActivePartnerCountByMonthList = [0,0,0,0,0,0,0,0,0,0,0,0]
          items.forEach((item) => {
            let key = item.key;
            let data = item.val();
            if(data['IsDeleted'] == 0){
              let month = new Date(data['CreatedDate']).getMonth()
              this.totalPartnerCountByMonthList[month] += 1;
              this.totalPartnerCount += 1;
              if(data['Status']=='Active' || data['IsActive']==1){
                this.totalActivePartnerCountByMonthList[month] += 1;
                this.totalActivePartnerCount += 1;
              }
            }
          });
          this.partnerSeries[0].data = this.totalActivePartnerCountByMonthList;
          this.partnerSeries[1].data = this.totalPartnerCountByMonthList;
          window.dispatchEvent(new Event('resize'))
        });
      }
    },
      getPartnerCodes() {
       if(this.userInfo){
         PartnerCodesService.getAll(this.userInfo).on("value", (items) => {
           this.totalCodeCount = 0;
           this.totalActiveCodeCount = 0;
           items.forEach((item) => {
             let key = item.key;
             let data = item.val();
             if(data['IsDeleted'] == 0){
                this.totalCodeCount += 1;
                 if(data['Status']=='Active' || data['IsActive']==1){
                 this.totalActiveCodeCount += 1;
               }
             }
           });
         });
       }
    },
     getClients() {
       this.totalClientCount = 0;
       this.totalActiveClientCount = 0;
       this.totalClientCountByMonth = [0,0,0,0,0,0,0,0,0,0,0,0]
      this.totalActiveClientCountByMonth = [0,0,0,0,0,0,0,0,0,0,0,0]
      if (this.userInfo) {
        ClientService.getAll(this.userInfo).on("value", items => {
          
          items.forEach(item => {
            let key = item.key;
            let data = item.val();
            if (data["IsDeleted"] == 0) {
              let month = new Date(data['CreatedDate']).getMonth()
              this.totalClientCount += 1;
              this.totalClientCountByMonth[month] += 1;
              if (data["Status"] == "Active" || data["IsActive"] == 1) {
                this.totalActiveClientCountByMonth[month] += 1
                this.totalActiveClientCount += 1;
              }
            }
          });
          this.clientSeries[0].data = this.totalActiveClientCountByMonth;
          this.clientSeries[1].data = this.totalClientCountByMonth;
          window.dispatchEvent(new Event('resize'))
        });
      }
    },
  getPayments() {
      if (this.userInfo) {
        PaymentService.getAll(this.userInfo).on("value", items => {
          this.totalAmount = 0;
          this.totalActiveAmount = 0;
          items.forEach(item => {
            let key = item.key;
            let data = item.val();
            if (data["IsDeleted"] == 0) {
              this.totalAmount += parseInt(data['Amount']);
            }
          });
          this.totalAmount = UtilService.convertIntToINR(this.totalAmount);
        });
      }
    },
  getPaymentsAmount () {
   if (this.userInfo) {
    PaymentService.getAll(this.userInfo).on("value", items => {  
    this.paymentAmount = [0,0,0,0,0,0,0,0,0,0,0,0]
      items.forEach(item => {
        let key = item.key;
        let data = item.val();
        let month = parseInt(new Date(data['PaidDate']).getMonth());
        if (data["IsDeleted"] == 0) {
          this.paymentAmount[month] += parseInt(data['Amount'])
        }
      });
       this.series[0]['data'].push(...this.paymentAmount)
       window.dispatchEvent(new Event('resize'))
    });
  }
},
getEarningsAmount () {
  if (this.userInfo) {
    EarningService.getAll(this.userInfo).on("value", items => {
      this.amount = [0,0,0,0,0,0,0,0,0,0,0,0]
      items.forEach(item => {
        let key = item.key;
        let data = item.val();
        let month = new Date(data['ClientStartDate']).getMonth();
        for(let i=0;i<12;i++)
        {
          if(month===i){
           this.amount[i]+= parseInt(data['Amount'])
          }
        }
      });
      this.series[1]['data'].push(...this.amount)
      window.dispatchEvent(new Event('resize'))
    });
  }
},
  getClientTypes() {
      if (this.userInfo) {
        ClientService.getAll(this.userInfo).on("value", items => {
           let perminute = 0
          let onetime = 0
          let percentage = 0
          let prepaid = 0
          items.forEach(item => {
            let key = item.key;
            let data = item.val();
            if (data["IsDeleted"] == 0) {
              if(data['ClientType']==='Onetime'){
                onetime+=1
              }else if(data['ClientType']==='Perminute'){
                perminute+=1
              }else if(data['ClientType']==='Percentage'){
                percentage+=1
              }else if(data['ClientType']==='Prepaid'){
                prepaid+=1
              }
            }
          });
          this.seriesClientType.push(perminute,onetime,percentage,prepaid)
        });
        window.dispatchEvent(new Event('resize'))
      }
    }
},
mounted(){

},
  created () {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.userInfo = userInfo;
    this.getPartnerCodes();
    this.getPartners();
    this.getClients();
    this.getPayments();
    this.getPaymentsAmount();
    this.getEarningsAmount();
    this.getClientTypes();
  }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
  .font-20{
    font-size: 20px;
  }
  .height-2{
    height: 7.1cm;
  }
}
/*! rtl:end:ignore */
</style>
